import React from 'react';
import './index.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 Starrr 的博客 · All Rights Reserved</p>
      <p className="purple-star">Designed with ★ by Starrr</p>
    </footer>
  );
};

export default Footer;